module.exports = __webpack_public_path__ + "static/media/chart-icons2.eb079102.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/chart-icons2.png
// module id = 661
// module chunks = 1